import type { NomoCharacter } from '@/mocks/characters';

interface ComingSoonProps {
  character: NomoCharacter;
}

export default function ComingSoon({ character }: ComingSoonProps) {
  return (
    <section className="bg-background-100 px-4 py-8 md:py-10">
      <div className="mx-auto max-w-6xl">
        <div className="reveal relative overflow-hidden rounded-lg border border-accent-200/70 bg-background-50 px-6 py-10 text-center md:px-12 md:py-14">
          <div className="absolute inset-x-0 top-0 h-1 bg-gradient-to-r from-accent-300 via-accent-500 to-accent-300"></div>

          <div className="mx-auto flex max-w-2xl flex-col items-center">
            <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-4 py-1.5 text-[11px] tracking-[0.24em] text-accent-700 uppercase">
              <i className="ri-time-line"></i>
              Coming Soon
            </span>

            <h2 className="mt-6 font-heading text-2xl leading-snug text-foreground-950 md:text-3xl">
              {character.name} 即将正式登场
            </h2>

            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              {character.name} 正在 {character.place} 酝酿它的一味「{character.flavor}」，
              很快会把「{character.wish}」带到你身边，敬请期待。
            </p>

            <div className="mt-8 flex items-center gap-2">
              <span className="h-2 w-2 animate-pulse rounded-full bg-accent-500"></span>
              <span className="h-2 w-2 rounded-full bg-accent-400"></span>
              <span className="h-2 w-2 rounded-full bg-accent-300"></span>
              <span className="ml-2 text-xs tracking-[0.24em] text-foreground-400 uppercase">
                筹备中 · 敬请期待
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}